import React from 'react';
import { connect } from 'react-redux';
import { showAlert } from 'src/actions/globalAlert';
import {
  create as createSendingDomain,
  remove as deleteDomain,
  get as getDomain,
  list as listSendingDomains,
  update as updateSendingDomain,
  verify,
  verifyAbuse,
  verifyAbuseToken,
  verifyDkim,
  verifyMailbox,
  verifyMailboxToken,
  verifyPostmaster,
  verifyPostmasterToken
} from 'src/actions/sendingDomains';
import { list as listSubaccounts } from 'src/actions/subaccounts';
import {
  createTrackingDomain,
  deleteTrackingDomain,
  listTrackingDomains,
  updateTrackingDomain,
  verifyTrackingDomain
} from 'src/actions/trackingDomains';
import { ROLES } from 'src/constants';
import { hasAccountOptionEnabled } from 'src/helpers/conditions/account';
import { hasRole } from 'src/helpers/conditions/user';
import { selectCondition } from 'src/selectors/accessConditionState';
import {
  selectAllSubaccountDefaultBounceDomains,
  selectAllowDefaultBounceDomains,
  selectHasAnyoneAtDomainVerificationEnabled,
  selectTrackingDomainCname,
  selectTrackingDomainCnameV2
} from 'src/selectors/account';
import { selectBounceDomainsRows, selectSendingDomainsRows } from 'src/selectors/sendingDomains';
import { hasSubaccounts } from 'src/selectors/subaccounts';
import { selectTrackingDomainsRows } from 'src/selectors/trackingDomains';
import { DomainsProvider } from '../context/DomainsContext';

function mapStateToProps(state) {
  return {
    sendingDomains: selectSendingDomainsRows(state),
    sendingDomainsListError: state.sendingDomains.listError,
    bounceDomains: selectBounceDomainsRows(state),
    listPending:
      state.sendingDomains.listLoading === true ||
      state.trackingDomains.listLoading === true ||
      state.subaccounts.listLoading === true,
    createPending: state.sendingDomains.createLoading || state.trackingDomains.createLoading,
    deletePending: state.trackingDomains.deleting || state.sendingDomains.deleting,
    updateTrackingPending: state.trackingDomains.updating,
    hasSubaccounts: hasSubaccounts(state),
    subaccounts: state.subaccounts.list,
    subaccountsPending: state.subaccounts.listLoading,
    tokenStatus: state.sendingDomains.verifyTokenStatus,
    trackingDomains: selectTrackingDomainsRows(state),
    trackingDomainsListError: state.trackingDomains.error,
    userName: state.currentUser.username,
    isByoipAccount: selectCondition(hasAccountOptionEnabled('byoip_customer'))(state),
    hasAnyoneAtEnabled: selectHasAnyoneAtDomainVerificationEnabled(state),
    allowDefault: selectAllowDefaultBounceDomains(state),
    allowSubaccountDefault: selectAllSubaccountDefaultBounceDomains(state),
    verifyDkimLoading: state.sendingDomains.verifyDkimLoading,
    verifyEmailLoading: state.sendingDomains.verifyEmailLoading,
    verifyBounceLoading: state.sendingDomains.verifyBounceLoading,
    verifyingTrackingPending: state.trackingDomains.verifyingTrackingPending,
    verifyTokenError: state.sendingDomains.verifyTokenError,
    trackingDomainCname: selectTrackingDomainCname(state),
    trackingDomainCnameV2: selectTrackingDomainCnameV2(state),
    verifyTokenLoading: state.sendingDomains.verifyTokenLoading,
    isReportingUser: hasRole(ROLES.REPORTING)(state),
    isTemplateUser: hasRole(ROLES.TEMPLATES)(state)
  };
}

const mapDispatchToProps = {
  createSendingDomain,
  createTrackingDomain,
  getDomain,
  listSendingDomains,
  updateSendingDomain,
  listSubaccounts,
  listTrackingDomains,
  verify,
  verifyDkim,
  verifyMailbox,
  verifyAbuse,
  verifyPostmaster,
  showAlert,
  deleteDomain,
  updateTrackingDomain,
  deleteTrackingDomain,
  verifyTrackingDomain,
  verifyMailboxToken,
  verifyAbuseToken,
  verifyPostmasterToken
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(({ children, ...props }) => {
  return <DomainsProvider value={props}>{children}</DomainsProvider>;
});
